import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Auth.css';

const SolicitarRecuperacion = () => {
  const [email, setEmail] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');
    setLoading(true);

    try {
      const API_URL = '/api';
      const response = await axios.post(`${API_URL}/password-reset/solicitar`, { email });

      setMensaje(response.data.mensaje);
      setEnviado(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al solicitar recuperación de contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>AppContra</h1>
        <h2>Recuperar Contraseña</h2>

        {!enviado ? (
          <>
            <p style={{ marginBottom: '20px', color: '#6b7280', fontSize: '14px' }}>
              Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.
            </p>

            {error && <div className="error-message">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="tu@email.com"
                />
              </div>

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar Enlace de Recuperación'}
              </button>
            </form>

            <p className="auth-footer">
              <Link to="/login">Volver al inicio de sesión</Link>
            </p>
          </>
        ) : (
          <>
            <div className="success-message" style={{
              padding: '15px',
              backgroundColor: '#d4edda',
              border: '1px solid #c3e6cb',
              borderRadius: '5px',
              color: '#155724',
              marginBottom: '20px'
            }}>
              {mensaje}
            </div>

            <p style={{ marginBottom: '20px', color: '#6b7280', fontSize: '14px' }}>
              Si el email existe en nuestro sistema, recibirás un correo con instrucciones para recuperar tu contraseña en los próximos minutos.
            </p>

            <p style={{ marginBottom: '20px', color: '#6b7280', fontSize: '14px' }}>
              Revisa tu bandeja de entrada y la carpeta de spam.
            </p>

            <p className="auth-footer">
              <Link to="/login">Volver al inicio de sesión</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default SolicitarRecuperacion;
